import { $error } from '@settings/errorContext';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';

import { notificationErrorsToSkip } from './constants';
import { getErrorTypeByMessage } from './helpers/getErrorTypeByMessage';
import { getMessageFromError } from './helpers/getMessageFromError';

const ErrorController = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [error, setError] = useState<any>(undefined);

  useEffect(() => {
    $error.subscribe((error) => {
      if (error !== undefined) {
        const errorMessage = getMessageFromError(error);
        const foundErrorType = getErrorTypeByMessage(errorMessage);

        if (!notificationErrorsToSkip.includes(foundErrorType)) {
          enqueueSnackbar(errorMessage, { variant: 'error' });
        }
      }
      setError(error);
    });
  }, []);

  useEffect(() => {
    if (
      error === undefined ||
      error.config.url.includes('/graphql?get_currency') ||
      error.config.url.includes('/graphql?countries')
    ) {
      return;
    }

    throw new Error(`Error: ${error}`);
  }, [error]);

  return <></>;
};

export default ErrorController;
